import { useCallback } from "react";

import { SharePromptSessionRow } from "./SharePromptSessionRow";

import { SharedSessionsManageView } from "@/components/SharedSessions";
import type { SharedSession } from "@/queries/prompts";

interface ManageViewProps {
  sessions: SharedSession[] | undefined;
  isLoadingSessions: boolean;
  onUpdate: (
    sessionId: string,
    fields: Partial<
      Pick<
        SharedSession,
        | "name"
        | "is_public"
        | "batch_enabled"
        | "chat_enabled"
        | "remix_enabled"
        | "label_name"
        | "version_number"
      >
    >,
  ) => void;
  onDelete: (sessionId: string) => void;
  onNewLink: () => void;
  hideModeSelector?: boolean;
}

export const ManageView = ({
  sessions,
  isLoadingSessions,
  onUpdate,
  onDelete,
  onNewLink,
  hideModeSelector = false,
}: ManageViewProps) => {
  const renderSessionRow = useCallback(
    (session: SharedSession, index: number) => (
      <SharePromptSessionRow
        key={session.id}
        session={session}
        index={index}
        onUpdate={onUpdate}
        onDelete={onDelete}
        hideModeSelector={hideModeSelector}
      />
    ),
    [onDelete, onUpdate, hideModeSelector],
  );

  return (
    <SharedSessionsManageView
      sessions={sessions}
      isLoadingSessions={isLoadingSessions}
      onNewLink={onNewLink}
      renderSessionRow={renderSessionRow}
    />
  );
};
